export default __webpack_public_path__ + "static/01 - Foto Joaquin-c93151d9a5c59b34e51e4691c35d892f.jpg";